export enum AtomButtonSizeEnum {
  LARGE = "large",
  LARGE_WIDE = "large-wide",
  MEDIUM = "medium",
  SMALL = "small",
}
